import { axiosInstance } from 'services';
import { AxiosResponse } from 'axios';

import { API_KEY } from 'constants/apis';

import { IPeopleData, IPeopleSortedParams, IPeopleStatsPesponse, IMainCountersData } from 'types/interfaces';
import { organizationsHeaderMock } from 'mockedData/mainPage';
import { peopleStatsMocked, topPeopleMocked } from 'mockedData/people.page';

export const PeopleApi = {
    getPeopleData: (params: IPeopleSortedParams): Promise<AxiosResponse<IPeopleData[]>> =>
        //axiosInstance.get<IPeopleData[]>('/people/top', { params }),
        Promise.resolve({
          data: topPeopleMocked,
          status: 200,
          statusText: "OK",
          headers: {},
          config: {},
          request: {},
        }),
    getPeopleStatsData: (): Promise<AxiosResponse<IPeopleStatsPesponse>> =>
        //axiosInstance.get<IPeopleStatsPesponse>('/people/stats'),
        Promise.resolve({
          data: peopleStatsMocked,
          status: 200,
          statusText: "OK",
          headers: {},
          config: {},
          request: {},
        }),
    getPeopleMainInfo: (): Promise<AxiosResponse<IMainCountersData>> =>    
       Promise.resolve({
        data: organizationsHeaderMock,
        status: 200,
        statusText: "OK",
        headers: {},
        config: {},
        request: {},
      })
        //axiosInstance.get<IMainCountersData>(`organization/${API_KEY}/last-update`),
};
